import HttpStatus from "../../../constants/HttpStatus";
import { errorAlert } from "../alert/defaultAlert";

/**
 * Responsável por tratar o objeto error retornado da API.
 * Trata tanto o objeto de erro customizado, enviado pela API, e também
 * a estrutura padrão das requisiões HTTP.
 * @param {object} error Objeto error da biblioteca AXIOS.
 */
export const ApiError = (error) => {
    const status = error?.response?.status;

    if (!status) {
        // Timeout não significa necessariamente queda da internet: o backend pode estar
        // processando uma operação demorada ou indisponível. Separar os casos evita orientar
        // o operador a verificar a conexão quando o problema está no tempo de resposta.
        if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
            errorAlert('O servidor demorou para responder. Aguarde alguns instantes e tente novamente.');
            return;
        }

        if (error?.message === 'Network Error' || error?.request) {
            errorAlert('Não foi possível alcançar o servidor. Verifique sua conexão ou tente novamente em instantes.');
            return;
        }

        errorAlert(error?.message || 'Não foi possível concluir a operação. Tente novamente.');
        return;
    }
    
    if(status === HttpStatus.BAD_REQUEST) {
        if(error.response.data.message) {
            errorAlert(error.response.data.message);
            return;
        } 

        errorAlert(error.response.data.detail)
    } else if(status === HttpStatus.INTERNAL_SERVER_ERROR) {        
        errorAlert(error.message);        
    } else {
        // Qualquer outro status (403, 404, 409, 503...) precisa dizer algo: antes o
        // operador só via o botão piscar e voltar ao normal, sem nenhuma explicação,
        // e concluía que o sistema tinha travado.
        errorAlert(error.response?.data?.message
            || error.response?.data?.detail
            || error.message
            || 'Não foi possível concluir a operação. Tente novamente.');
    }
}
